import { render, staticRenderFns } from "./SalesIncome.vue?vue&type=template&id=a9f27b46&"
import script from "./SalesIncome.vue?vue&type=script&lang=js&"
export * from "./SalesIncome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports